import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
const forWho = ['Padres primerizos que se sienten sobrepasados y al límite del agotamiento.', 'Mamás y papás que trabajan y necesitan estar lúcidos durante el día.', 'Familias que buscan una alternativa compasiva a los métodos de "dejar llorar" (Cry It Out).', 'Padres de bebés entre 0 y 24 meses que se despiertan múltiples veces por noche.'];
const notForWho = ['Buscas una solución mágica sin estar dispuesto a seguir una secuencia de 7 minutos.', 'Prefieres métodos de entrenamiento rígidos basados únicamente en el llanto.'];
export function WhoIsThisFor() {
  return <section className="py-24 px-6 bg-white" data-id="element-179">
      <div className="max-w-5xl mx-auto" data-id="element-180">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-181">
          {/* For Who */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-brand-cream/50 p-8 md:p-10 rounded-3xl border border-brand-green/20" data-id="element-182">
            <h3 className="text-2xl font-serif font-bold text-brand-text mb-8 flex items-center" data-id="element-183">
              <span className="bg-brand-green/20 text-brand-green p-2 rounded-full mr-4" data-id="element-184">
                <CheckCircle2 className="w-6 h-6" data-id="element-185" />
              </span>
              PARA TI SI ERES:
            </h3>
            <ul className="space-y-6" data-id="element-186">
              {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-187">
                  <CheckCircle2 className="w-5 h-5 text-brand-green mr-3 flex-shrink-0 mt-1" data-id="element-188" />
                  <span className="text-brand-text leading-relaxed" data-id="element-189">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Who */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gray-50 p-8 md:p-10 rounded-3xl border border-gray-200" data-id="element-190">
            <h3 className="text-2xl font-serif font-bold text-brand-text mb-8 flex items-center opacity-80" data-id="element-191">
              <span className="bg-gray-200 text-gray-500 p-2 rounded-full mr-4" data-id="element-192">
                <XCircle className="w-6 h-6" data-id="element-193" />
              </span>
              NO ES PARA TI SI:
            </h3>
            <ul className="space-y-6 opacity-80" data-id="element-194">
              {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-195">
                  <XCircle className="w-5 h-5 text-gray-400 mr-3 flex-shrink-0 mt-1" data-id="element-196" />
                  <span className="text-brand-text leading-relaxed" data-id="element-197">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}